// extracted by mini-css-extract-plugin
export var card = "_kt-5";
export var cardSelected = "_kt-4";
export var image = "_kt-3";
export var modal = "_kt-0";
export var modalContent = "_kt-1";
export var table = "_kt-2";